export const displayFormattedRecipient = {
    Patient: "Patient",
    HealthcareProfessional: "Healthcare provider",
} as const;
